<script setup>
import { computed, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { trans } from 'laravel-vue-i18n';
import { useScaleReader } from '@/composables/scaleReader';

const toast = useToast();
const {
    isSupported,
    connectionState,
    errorType,
    lastAttemptFailed,
    clearError,
    connect,
    disconnect,
} = useScaleReader();

const connectLabelKey = computed(() => (lastAttemptFailed.value ? 'label.scale_retry' : 'label.scale_connect'));

watch(errorType, (type) => {
    if (type === 'open_failed') {
        toast.error(trans('label.scale_connect_failed'));
    }
    if (type) {
        clearError();
    }
});
</script>

<template>
<div v-if="isSupported" class="scale-status">
    <FontAwesomeIcon icon="weight-scale" class="scale-status-icon" />
    <button
        v-if="connectionState === 'disconnected'"
        type="button"
        class="scale-status-connect-btn"
        @click="connect">{{ $t(connectLabelKey) }}</button>
    <template v-else-if="connectionState === 'connecting'">
        <FontAwesomeIcon icon="circle-notch" spin class="scale-status-spinner" />
        <span class="scale-status-label">{{ $t('label.scale_connecting') }}</span>
    </template>
    <template v-else>
        <span class="scale-status-dot" />
        <span class="scale-status-label">{{ $t('label.scale_connected') }}</span>
        <button
            type="button"
            class="scale-status-disconnect-btn"
            :aria-label="$t('label.disconnect')"
            @click="disconnect">
            <FontAwesomeIcon icon="times" />
        </button>
    </template>
</div>
</template>
